// @angular
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

// @ngrx
import { StoreModule } from '@ngrx/store';
import { reducers } from './store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';

// clarity
import { ClarityModule } from 'clarity-angular';

// firebase
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';

// auth0
import { JwtModule } from '@auth0/angular-jwt';

// environment
import { environment } from '../environments/environment';

// app
import { AppRouterModule } from './app.routes';
import { AuthGuard } from './shared/guards/auth.guard';
import { AppComponent } from './app.component';

// pages
import { ProjectsComponent } from './pages/projects/projects.component';
import { EntranceComponent } from './pages/entrance/entrance.component';
import { ProfileComponent } from './pages/profile/profile.component';

// components
import { ActionsComponent } from './pages/actions/actions.component';
import { ActionCardComponent } from './components/action-card/action-card.component';
import { InviteProjectComponent } from './components/invite-project/invite-project.component';
import { ProjectCardComponent } from './components/project-card/project-card.component';
import { EntitiesComponent } from './pages/entities/entities.component';

// services
import { AuthService, LOCALSTORAGE_TOKEN_NAME } from './store/services/auth.service';
import { AlertService } from './store/services/alert.service';
import { ActionService } from './store/services/action.service';
import { FirestoreService } from './shared/firestore/firestore.service';
import { DialogflowService } from './shared/services/dialogflow.service';

// effects
import { AlertEffects } from './store/effects/alert';

// pipes
import { DocPipe } from './shared/pipes/doc.pipe';
import { CollectionPipe } from './shared/pipes/collection.pipe';
import { DayPipe } from './shared/pipes/day.pipe';
import { MonthPipe } from './shared/pipes/month.pipe';
import { FromNowPipe } from './shared/pipes/from-now.pipe';

@NgModule({
  declarations: [
    AppComponent,

    // pages
    ProjectsComponent,
    EntranceComponent,
    ProfileComponent,
    DocPipe,
    ActionsComponent,
    ActionCardComponent,
    CollectionPipe,
    DayPipe,
    MonthPipe,
    FromNowPipe,
    InviteProjectComponent,
    ProjectCardComponent,
    EntitiesComponent,

    // components
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CommonModule,
    FormsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem(LOCALSTORAGE_TOKEN_NAME);
        },
      }
    }),
    StoreModule.forRoot(reducers),
    StoreDevtoolsModule.instrument({
      maxAge: 25 //  Retains last 25 states
    }),
    EffectsModule.forRoot([ AlertEffects ]),
    ClarityModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AppRouterModule,
  ],
  providers: [
    AuthService,
    AuthGuard,
    AlertService,
    ActionService,
    FirestoreService,
    DialogflowService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/app.module.ts